import React, { Component } from 'react';

import './Home.css';

class Home extends Component {
    componentDidMount() {


    }

    render() {
        return (
            <div className="home">
                <h5><i className="ion ion-ios-home-outline" /> Once you have an account, this will be your main dashboard to quickly view how you're doing.</h5>
            </div>
        );
    }
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Home/Home.js